import { type ClusterGroup } from "~/features/selectionAssistant/housing/types/types";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

function getApiUrl(): string {
  return occUrl("/search/clustergroups?selectionGroup=HOUSINGS");
}

export interface HousingClusterGroupListResponseDTO {
  groups?: HousingClusterGroupDTO[];
}

type HousingClusterGroupDTO = Omit<ClusterGroup, "clusterItems"> & {
  clusterItems?: ClusterGroup["clusterItems"];
};

export async function getHousingClusterGroups(): Promise<ClusterGroup[]> {
  const response = await occFetch(getApiUrl());

  if (!response.ok) {
    throw Error(response.statusText);
  }

  const dto = (await response.json()) as HousingClusterGroupListResponseDTO;
  const data: ClusterGroup[] = (dto.groups ?? []).map((group) => ({
    ...group,
    clusterItems: group.clusterItems ?? [],
  }));

  data.forEach((group) => {
    if (group.code === "housing_type") {
      group.clusterItems.forEach((item) => (item.imageUrl = HOUSING_TYPE_IMAGES[item.code]));
    }
    if (group.code === "housing_shapes") {
      group.clusterItems.forEach((item) => (item.imageUrl = HOUSING_SHAPE_IMAGES[item.code]));
    }
  });

  return data;
}

const HOUSING_TYPE_IMAGES: Record<string, string> = {
  housing_sort__Plummer: "https://cdn.schaeffler-ecommerce.com/cdn/00197793_e.png",
  "housing_sort__Take-up": "https://cdn.schaeffler-ecommerce.com/cdn/001977A1_e.png",
  housing_sort__Flanged: "https://cdn.schaeffler-ecommerce.com/cdn/001977A7_e.png",
};

const HOUSING_SHAPE_IMAGES: Record<string, string> = {
  housing_shape__Dreieck_eckig: "https://cdn.schaeffler-ecommerce.com/cdn/0019779D_e.png",
  housing_shape__Dreieck: "https://cdn.schaeffler-ecommerce.com/cdn/0019779A_e.png",
  housing_shape__Viereck: "https://cdn.schaeffler-ecommerce.com/cdn/0019779F_e.png",
  housing_shape__Oval: "https://cdn.schaeffler-ecommerce.com/cdn/001977A7_e.png",
  housing_shape__Rund: "https://cdn.schaeffler-ecommerce.com/cdn/00197799_e.png",
};
